import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "./ApiRequest";
const { WineDataSet, Notification } = require("./EndPoints");

export const CreateDataSet = (payload) => {
  return postRequest(WineDataSet.WINE_DATA, payload);
};
export const GetDataSet = (
  currentPage,
  pageSize,
  search = "",
  sort = "",
  filter = ""
) => {
  return getRequest(
    `${WineDataSet.WINE_DATA}?page=${currentPage}&per_page=${pageSize}&order=${sort}&query=${search}&filter=${filter || ""}`
  );
};
export const DeleteDataSet = (id) => {
  return deleteRequest(`${WineDataSet.WINE_DATA}/${id}`);
};
export const UpdateDataSet = (payload, id) => {
  return patchRequest(`${WineDataSet.WINE_DATA}/${id}`, payload);
};
export const GetSingleDataSet = (id) => {
  return getRequest(`${WineDataSet.WINE_DATA}/${id}`);
};

export const SearchWineData = (query) => {
  return getRequest(`${WineDataSet.WINE_DATA_SEARCH}?query=${query}`);
};
export const GetUnapprovedDataSet = (
  currentPage,
  pageSize,
  search = "",
  sort = "",
  filter = ""
) => {
  return getRequest(
    `${WineDataSet.WINE_DATA_UNAPPROVED}?page=${currentPage}&per_page=${pageSize}&order=${sort}&query=${search}&filter=${filter || ""}`
  );
};
export const GetSingleUnapprovedDataSet = (id) => {
  return getRequest(`${WineDataSet.WINE_DATA_UNAPPROVED}/${id}`);
};

export const UpdateUnapproved = (id, payload) => {
  return patchRequest(`${WineDataSet.WINE_DATA_UNAPPROVED}/${id}`, payload);
};
export const ApproveUnapproved = (id) => {
  return patchRequest(`${WineDataSet.WINE_DATA_APPROVED}/${id}`);
};
// export const GetSinglePageDataSet = (id) => {
//   return getRequest(`${WineDataSet.WINE_DATA}/${id}`);
// };
// export const GetDataSetBYCodAPI = (CodId) => {
//   return getRequest(`${WineDataSet.WINE_DATA_GET}/${CodId}`);
// };

export const GetAdminNotifications = () => {
  return getRequest(Notification.ADMIN_NOTIFICATIONS_List);
};
export const ReadNotificationAPI = (id) => {
  return postRequest(`${Notification.ADMIN_NOTIFICATION_READ}/${id}`);
};
export const DeleteWineDataRequest = (id) => {
  return deleteRequest(`${WineDataSet.WINE_DATA_UNAPPROVED}/${id}`);
};

export const AddNotificationCredentials = (payload) => {
  return postRequest(`${Notification.SETTING_CREDENTIALS}`, payload);
};
export const GetNotificationCredentials = (id) => {
  return getRequest(`${Notification.SETTING_CREDENTIALS}/${id}`);
};
export const UpdateNotificationCredentials = (id, payload) => {
  return patchRequest(`${Notification.SETTING_CREDENTIALS}/${id}`, payload);
};

export const GetRequestSuggestions = (id) => {
  return getRequest(`${WineDataSet.WINE_DATA_UNAPPROVED}/${id}/suggestions`);
};
export const LinkRequestToWine = (id, wineUuid) => {
  return postRequest(`${WineDataSet.WINE_DATA_UNAPPROVED}/${id}/link`, {
    wine_uuid: wineUuid,
  });
};
export const AIProposeRequest = (id) => {
  return postRequest(`${WineDataSet.WINE_DATA_UNAPPROVED}/${id}/ai-propose`);
};
